/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminAdvertisementAdd() {
  const history = useHistory();
  const [savingFile, setSavingFile] = useState<File>();
  const [sortNumber, setSortNumber] = useState<Number>();
  const [siteUrlText, setSiteUrlText] = useState('http://www.');
  const [collegeText, setCollegeText] = useState('');
  const [targetText, setTargetText] = useState('_blank');
  const [fileUrl, setFileUrl] = useState('');
  const dispatch = useDispatch();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  const onClickSave = async () => {
    const savedData = await server
      .addAdvertisements({
        sort: Number(sortNumber),
        siteUrl: siteUrlText,
        college: collegeText,
        target: targetText,
      })
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          dispatch(toast.info({ message: '정상적으로 저장되었습니다.' }));
        }
        history.push('/admin/banner-logo/advertisement');
        return payload;
      });

    if (savedData !== undefined) {
      const savedDataId = savedData.id;
      if (savingFile !== undefined) {
        await server
          .AdvertisementsFileUpload(savedDataId, { image: savingFile })
          .then(() => {
            history.push('/admin/banner-logo/advertisement');
          })
          .catch((error) => {
            dispatch(toast.error({ message: '첨부파일 에러 ' }));
            return error;
          });
      }
    }
  };

  return (
    <main className="images wrapper">
      <div className="title">
        <h1>광고 등록하기</h1>
        <div className="buttons">
          <button type="button" onClick={() => onClickSave()}>
            등록
          </button>
        </div>
      </div>
      <div className="content">
        <ul className="inputs">
          <li className="input">
            <span className="required">정렬 순서</span>
            <input
              type="number"
              onChange={(e: any) => {
                setSortNumber(Number(e.target.value));
              }}
            />
          </li>
          {/* <li>
            <span className="required">현재 광고 이미지</span>
            <span>
              <img src="../assets/images/banner/main_01.jpg" alt="" />
            </span>
          </li> */}
          <li>
            <span className="required">등록할 광고 이미지</span>
            <div className="input-file-container">
              <input
                className="input-file"
                id="file02"
                type="file"
                onChange={(e) => {
                  if (
                    e.target !== null &&
                    e.target.files !== null &&
                    e.target.files[0] !== undefined
                  ) {
                    setSavingFile(e.target.files[0]);
                    const preview = e.target.files[0];
                    const imageUrl = URL.createObjectURL(preview);
                    setFileUrl(imageUrl);
                  }
                }}
              />
              <label tabIndex={0} htmlFor="file02" className="input-file-trigger">
                파일 선택
              </label>
            </div>
            <img
              src={fileUrl}
              alt={savingFile?.name}
              onLoad={() => {
                dispatch(toast.info({ message: '이미지 업로드 완료.' }));
                window.URL.revokeObjectURL(fileUrl);
              }}
            />
            <small>※ 사이즈: 1200x326 (픽셀)</small>
          </li>
          <li>
            <span>연결 URL</span>
            <input
              className="full"
              type="url"
              defaultValue={siteUrlText}
              onChange={(e) => {
                setSiteUrlText(e.target.value);
              }}
            />
            <small>※ 대학교재 배너일 경우에는 입력하지 않으셔도 됩니다.</small>
          </li>
          <li>
            <span>대학명</span>
            <input
              type="text"
              id="college"
              value={collegeText}
              onChange={(e) => {
                setCollegeText(e.target.value);
              }}
            />
            <small>※ 해당 대학교재 판매시</small>
          </li>
        </ul>
      </div>
    </main>
  );
}
